import { Form, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { ModalSizes } from "../../../../common/constants";
import { validations } from "../../../../common/utils/validationUtils";
import { CommissionKindSelect } from "../../batch/components/CommissionKindSelect";
import { CommissionKind } from "../../batch/enums";

type Props = {
  onSave: (newTab: CommissionKind) => void;
  onCancel: VoidFunction;
  isOpen: boolean;
  excluded: CommissionKind[];
};

export const AddCommissionKindTabModal = ({ isOpen, onCancel, onSave, excluded }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<{ commissionKind: CommissionKind }>();

  const handleSubmit = () => {
    form.validateFields().then((values) => onSave(values.commissionKind));
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      title={t("commissions.productCommissionsSettings.titles.addCommissionKind")}
      open={isOpen}
      onOk={handleSubmit}
      onCancel={onCancel}
      okText={t("common.add")}
      cancelText={t("common.cancel")}
      afterClose={form.resetFields}
    >
      <Form layout="vertical" form={form} name="commissionKindForm">
        <Form.Item
          name="commissionKind"
          label={t("commissions.batch.enums.commissionKind._label")}
          rules={[validations.notNull]}
        >
          <CommissionKindSelect excluded={excluded} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
